export default {
  infoTitle: {
    id: 'insurance_backup_plus_drawer_info_title',
    defaultMessage: 'Frequently Asked Questions',
  },
  infoQuestion1: {
    id: 'insurance_backup_plus_drawer_info_question1',
    defaultMessage:
      'What’s the difference between BackUp+ and the standard warranty?',
  },
  infoResponse1: {
    id: 'insurance_backup_plus_drawer_info_response1',
    defaultMessage:
      'Refurbisher warranty is included in every purchase on Back Market. This warranty only covers defects and functionality issues. With our insurance plans, you can get full damage, theft cover, and other perks.',
  },
  infoQuestion2: {
    id: 'insurance_backup_plus_drawer_info_question2',
    defaultMessage: 'Can I cancel BackUp+?',
  },
  infoResponse2: {
    id: 'insurance_backup_plus_drawer_info_response2',
    defaultMessage:
      'If you cancel your order within 30 days, you will receive a full refund if you haven’t used it.',
  },
  infoQuestion3: {
    id: 'insurance_backup_plus_drawer_info_question3',
    defaultMessage: 'How do I report a claim?',
  },
  infoResponse3: {
    id: 'insurance_backup_plus_drawer_info_response3',
    defaultMessage:
      'You can report your claim on our partner portal within 10 working days of the date you became aware of the issue.',
  },
  infoQuestion4: {
    id: 'insurance_backup_plus_drawer_info_question4',
    defaultMessage: 'Who is our protection partner?',
  },
  infoResponse4: {
    id: 'insurance_backup_plus_drawer_info_response4',
    defaultMessage:
      'We’re partnering with protection provider Asurion to keep your tech safe, so you’re not sorry.',
  },
}
